import React from 'react';
import './WhatsAppButton.css';
import WhatsAppIcon from '../../Atoms/IconWhatsApp/IconWhatsApp';

const WhatsAppButton = ({ phoneNumber, message = ''}) => {
  // Asegurarse de que el número no tenga caracteres extraños.
  const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
  const encodedMessage = encodeURIComponent(message);

  const whatsappLink = `https://wa.me/${cleanedPhoneNumber}${message ? `?text=${encodedMessage}` : ''}`;

  return (
    <a
      href={whatsappLink}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      <WhatsAppIcon />
    </a>
  );
};

export default WhatsAppButton;